import {
  Snackbar,
  Alert,
  CircularProgress,
  Backdrop,
  Icon,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
  MenuItem,
  Button,
  Switch,
  FormControlLabel,
  Divider,
  InputAdornment,
  Grid,
  Chip,
} from "@mui/material";

import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";

import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import axios from "axios.js";
import usePageTitle from "app/pageTitle";
import KPI from "./components/kpi_cards";
import TrendChart from "./components/trend_line";
import HorizontalBarChart from "./components/hr_bar";
import DonutChart from "./components/donut";
import ValueCountTable from "./components/tb";
import VerticalBarChart from "./components/vr_bar";
function OpsSalesInsightsPage() {
  const title = "Sales Insights";
  usePageTitle(title);
  const navigate = useNavigate();
  const { filterType, filterRef } = useParams();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("info");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);

  const [resultData, setResultData] = useState(null);
  const [insights, setInsights] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      let queryParams = {};
      if (filterType && filterRef) {
        queryParams[filterType] = filterRef;
      }
      console.log(queryParams);
      setShowLoading(true);
      await axios
        .get(`/portal/ops/sales/insights.json`, { params: queryParams })
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            console.log(result.data.data);
            setResultData(result.data);
            setInsights(result.data.data.insights);
            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data?.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mt={1} mb={5}>
        {pageLoaded && (
          <MDBox>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <KPI
                  title="Total Revenue"
                  value={insights.summary.value}
                  currency={resultData.currency}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <KPI title="Total Sales" value={insights.summary.count} />
              </Grid>

              <Grid item xs={12} md={4}>
                <KPI title="Total Quantity" value={insights.summary.quantity} />
              </Grid>

              <Grid item xs={12} md={6}>
                <DonutChart
                  title="Revenue Breakdown"
                  data={insights.status.value}
                  dataKey="value"
                  currency={resultData.currency}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <VerticalBarChart
                  title="Sales Breakdown"
                  data={insights.status.count}
                  dataKey="count"
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <TrendChart
                  title="Revenue Trend"
                  data={insights.trend.value}
                  dataKey="value"
                  currency={resultData.currency}
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <TrendChart title="Sales Trend" data={insights.trend.count} dataKey="count" />
              </Grid>

              <Grid item xs={12} md={6}>
                <HorizontalBarChart
                  title="Product Revenue"
                  data={insights.product.value}
                  dataKey="value"
                  currency={resultData.currency}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <HorizontalBarChart
                  title="Product Sales"
                  data={insights.product.count}
                  dataKey="count"
                />
              </Grid>

              {filterType !== "entity" && (
                <>
                  {" "}
                  <Grid item xs={12} md={6}>
                    <DonutChart
                      title="Revenue by Business Entity"
                      data={insights.relationship.value}
                      dataKey="value"
                      currency={resultData.currency}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <HorizontalBarChart
                      title="Sales by Business Entity"
                      data={insights.relationship.count}
                      dataKey="count"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <ValueCountTable
                      title="Business Entities"
                      data={insights.tables.entity}
                      currency={resultData.currency}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <ValueCountTable
                      title="Agents"
                      data={insights.tables.agent}
                      currency={resultData.currency}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <ValueCountTable
                      title="Business Entity Groups"
                      data={insights.tables.group}
                      currency={resultData.currency}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default OpsSalesInsightsPage;
